<template>
  <div class="uni-max row m-0 calpage-d">
    <div class="col-lg-6 cd-padding">
      <div class="cal-results">
        <div class="p-4 uni-max-xs">
          <div class="cal-result-div">
            <div class="cal-subtitle">Grand Total</div>
            <div class="cal-redtitle mt-2">RM {{addComma(sgrandTotal)}}</div>
          </div>
        </div>
        <div class="border-t p-4 uni-max-xs">
          <div class="cal-title">Sales &amp; Purchase</div>
          <div class="row m-0">
            <div class="pl-0 col-7">
              <div class="mb-3">S&amp;P Legal Fee</div>
              <div class="mb-3">S&amp;P Stamp Duty</div>
              <div>Total</div>
            </div>
            <div class="pr-0 col-5">
              <div class="font-weight-bold mb-3">RM {{addComma(sspLegal)}}</div>
              <div class="font-weight-bold mb-3">RM {{addComma(sspDuty)}}</div>
              <div class="font-weight-bold">RM {{addComma(sspTotal)}}</div>
            </div>
          </div>
        </div>
        <div class="border-t p-4 uni-max-xs">
          <div class="cal-title">Loan</div>
          <div class="row m-0">
            <div class="pl-0 col-7">
              <div class="mb-3">Loan Legal Fee</div>
              <div class="mb-3">Loan Stamp Duty</div>
              <div>Total</div>
            </div>
            <div class="pr-0 col-5">
              <div class="font-weight-bold mb-3">RM {{addComma(sloanLegal)}}</div>
              <div class="font-weight-bold mb-3">RM {{addComma(sloanDuty)}}</div>
              <div class="font-weight-bold">RM {{addComma(sloanTotal)}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="col-lg-6 cd-padding">
      <div class="cal-form-container">
        <div class="cal-label">Purchase Price</div> 
        <div class="filter-price-wrapper">
          <span class="filter-price-rm">RM</span>
          <input type='number' v-model="propPrice" class="filter-price-range">
        </div>
        
        <div class="cal-label">Percentage of Loan Amount (%)</div> 
        <div class="filter-price-wrapper">
          <input type='number' v-model="moF" class="filter-price-range" placeholder="E.g. 80  (% of your loan amount)">
          <span class="filter-price-rm ml-auto">%</span>
        </div>

        <button @click="calculate" class="cal-btn">
          <span v-if="isloaded">Calculate my Monthly Repayment</span>
          <div v-else class="spinner-border text-light" role="status" style="width: 1rem; height: 1rem;">
            <span class="sr-only">Loading...</span>
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LegalFeeStampDuty',
    data: function () {
      return {
        // Legal Fees
        propPrice: null,
        moF: null,
        isloaded: true,

        // Results (update when press calculate)
        sspLegal: '',
        sspDuty: '',
        sspTotal: '',
        sloanLegal: '',
        sloanDuty: '',
        sloanTotal: '',
        sgrandTotal: '',
      }
    },
    mounted() {
      this.propPrice = 500000
      this.moF = 90;
      
      this.sspLegal = this.spLegal;
      this.sspDuty = this.spDuty;
      this.sspTotal = this.spTotal;
      this.sloanLegal = this.loanLegal;
      this.sloanDuty = this.loanDuty;
      this.sloanTotal = this.loanTotal;
      this.sgrandTotal = this.grandTotal;
    },
    computed: {
      feePerc() {
        var feep = 0;
        if (this.propPrice <= 500000) {
          feep = this.propPrice * 0.01;
        }
        if (this.propPrice > 500000 && this.propPrice <= 1000000) {
          feep = 5000 + (this.propPrice - 500000) * 0.008;
        }
        if (this.propPrice > 1000000 && this.propPrice <= 3000000) {
          feep = 9000 + (this.propPrice - 1000000) * 0.007;
        }
        if (this.propPrice > 3000000 && this.propPrice <= 5000000) {
          feep = 23000 + (this.propPrice - 3000000) * 0.006;
        }
        if (this.propPrice > 5000000) {
          feep = 35000 + (this.propPrice - 5000000) * 0.005;
        }
        if (feep < 500) {
          feep = 500;
        }
        return feep
      },
      spLegal() { return Math.round(parseFloat(this.feePerc)) },
      spDuty() {
        var sp = 0;
        if (this.propPrice <= 100000) {
          sp = this.propPrice * 0.01;
        }
        if (this.propPrice > 100000 && this.propPrice <= 500000) {
          sp = 1000 + (this.propPrice - 100000) * 0.02;
        }
        if (this.propPrice > 500000 && this.propPrice <= 1000000) {
          sp = 9000 + (this.propPrice - 500000) * 0.03;
        }
        if (this.propPrice > 1000000) {
          sp = 24000 + (this.propPrice - 1000000) * 0.04;
        }
        return this.isEven(sp)
      },
      spTotal() { return Math.round(parseFloat(this.spLegal) + parseFloat(this.spDuty)) },
      loanLegal() { return Math.round(parseFloat(this.feePerc) * parseFloat(this.moF) / 100) },
      loanDuty() { return this.isEven(parseFloat(this.propPrice) * parseFloat(this.moF) * 0.00005) },
      loanTotal() { return Math.round(parseFloat(this.loanLegal) + parseFloat(this.loanDuty)) },
      grandTotal() { return Math.round(parseFloat(this.spTotal) + parseFloat(this.loanTotal)) },
    },
    methods: {
      addComma: function (num) {
        if (num != null) {
          var num_parts = num.toString().split(".");
          num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          return num_parts.join(".");
        } else {
          return '';
        }
      },
      isEven: function (n) {
        var num = n;
        if (Math.floor(n) % 2 == 0) { // is even with decimal
          num = Math.round(n)
          if (num % 2 != 0) {
            num = num + 1
          }
        } else { // is odd with decimal
          num = Math.floor(n) + 1;
        }
        return num;
      },
      calculate: function() {
        this.isloaded = false;

        setTimeout(() => {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });
          this.isloaded = true;

          // Update Results
          this.sspLegal = this.spLegal;
          this.sspDuty = this.spDuty;
          this.sspTotal = this.spTotal;
          this.sloanLegal = this.loanLegal;
          this.sloanDuty = this.loanDuty;
          this.sloanTotal = this.loanTotal;
          this.sgrandTotal = this.grandTotal;
        }, 500);
      }
    },
  }
</script>